import { render, staticRenderFns } from "./job_detail.html?vue&type=template&id=78a7b22f&scoped=true&"
import script from "./job_detail.vue?vue&type=script&scoped=true&lang=js&"
export * from "./job_detail.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./job_detail.scss?vue&type=style&index=0&id=78a7b22f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a7b22f",
  null
  
)

export default component.exports